<template>

  <table class="table table-att-month" :class="{ 'loading-calendar': workDaysLoading }">
    <thead>
    <tr>
      <th class="th-date">{{ trans.date }}</th>
      <th colspan="2">{{ trans.work_time }}</th>
    </tr>
    </thead>

    <tbody v-cloak>
    <tr
      v-for="(day) in days"
      v-bind:key="day.date"
      :class="{'weekend': (day.isWeekend || day.offDay) }"
    >

      <td class="td-date">
        <span v-if="day.offDay" class="holiday"><i class="fas fa-star"></i>&nbsp;{{ day.offDay }}</span>
        <span class="date">
                        <b>{{ day.date | date('DD') }}</b>
                    </span>
        <span class="week-day">{{ day.date | date('dddd') }}</span>
      </td>

      <td>
        <div v-for="(interval) in day.shiftPlan.intervals"
             v-bind:key="interval.id"
             class="d-block"
        >
          <template v-if="interval.planIntervalType === 'work'">
            <span class="badge badge-dark">
              {{ interval.from | datetime('HH:mm') }} - {{ interval.to | datetime('HH:mm') }}
            </span>
            <span class="badge badge-light">
              {{ intervalLength(interval.from, interval.to) }}&nbsp;{{ trans.hours }}
            </span>
            <span v-if="day.shiftPlan.otherRestaurant">({{ day.shiftPlan.otherRestaurant }})</span>
          </template>

          <template v-else>
            <div class="work-holiday">
              <span class="badge badge-holiday">
                {{ interval.planIntervalTypeLabel }}
              </span>
              <span class="badge badge-light">
                {{ intervalLength(interval.from, interval.to) }}&nbsp;{{ trans.hours }}
              </span>
              <span v-if="day.shiftPlan.otherRestaurant">({{ day.shiftPlan.otherRestaurant }})</span>
            </div>
          </template>
        </div>
      </td>

      <td class="text-center">
        <div class="table-att-month__buttons" v-if="day.shiftPlan.date !== null">
          <button
            type="button"
            class="btn btn-warning btn-sm btn-square-loading "
            @click="editPlan(day)"
          >
            <i class="fal fa-fw fa-pencil"></i>
          </button>

          <form @submit.prevent="deleteItem(day.shiftPlan.id)" style="display: inline-block;">
            <button
              type="submit"
              class="btn btn-danger btn-sm btn-square-loading"
              title="Zmazať"
            >
              <i class="fal fa-fw fa-trash-alt"></i>
            </button>
          </form>
        </div>

        <div class="table-att-month__buttons" v-else>
          <button
            type="button"
            class="btn btn-sm btn-primary btn-add-date"
            @click="editPlan(day)"
          >
            <i class="fal fa-fw fa-plus"></i>
          </button>
        </div>
      </td>
    </tr>
    </tbody>
  </table>
</template>


<script>
import {formatIntervalLength} from "../../utils";

export default {
  name: 'shift-plan-calendar',
  data() {
    return {
      toggleLoadingDate: [],
      deleteLoadingDate: null,
      selectedDays: []
    }
  },

  props: {
    'employeeContract': {
      type: Object,
    },
    'trans': {
      type: Object
    },
    'workType': {
      type: String
    },
    'days': {
      type: Array
    },
    'workDaysLoading': {
      type: Boolean
    }
  },

  methods: {
    deleteItem(id) {
      var _this = this

      this.$modal.show('dialog', {
        title: this.trans.deleteWarning.title,
        text: this.trans.deleteWarning.text,
        buttons: [{title: this.trans.deleteWarning.no}, {
          title: '<span class="btn-dialog btn-danger">' + this.trans.deleteWarning.ok + '<span>',
          handler: function handler() {

            _this.$modal.hide('dialog');

            axios.delete('/shift-plans/plans/' + id)
              .then((response) => {
                _this.$emit('refresh-calendar')

                _this.$notify({
                  type: 'success',
                  title: 'Success!',
                  text: response.data.message ? response.data.message : 'Item successfully deleted.'
                });
              })
              .catch((error) => {
                _this.$emit('refresh-calendar')
                _this.$notify({
                  type: 'error',
                  title: 'Error!',
                  text: error.response.data.message ? error.response.data.message : 'An error has occured.'
                });
              })
          }
        }]
      });
    },

    editPlan(day) {
      this.$modal.show('edit-shift-plan', {day});
    },

    intervalLength(start, end) {
      return formatIntervalLength(start, end);
    },
  },

  filters: {
    date: function date(date) {
      var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'YYYY-MM-DD';

      var date = (0, moment)(date);
      return date.isValid() ? date.format(format) : "";
    },
    datetime: function datetime(_datetime) {
      var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'YYYY-MM-DD HH:mm:ss';

      var date = (0, moment)(_datetime);
      return date.isValid() ? date.format(format) : "";
    },
    time: function time(_time) {
      var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'HH:mm:ss';

      var date = (0, moment)('2000-01-01 ' + _time);
      return date.isValid() ? date.format(format) : "";
    },
    floatToTime: function floatToTime(number) {
      var date = new Date(number * 3600 /* sec per hr */
        * 1000 /* msec per sec */);
      return ('0' + date.getUTCHours()).slice(-2) + ':' +
        ('0' + date.getUTCMinutes()).slice(-2);
    },
  }

}
</script>

<style lang="scss">
$puff: url('data:image/svg+xml;utf8,<svg width="44" height="44" viewBox="0 0 44 44" xmlns="http://www.w3.org/2000/svg" stroke="#4273FA"><g fill="none" fill-rule="evenodd" stroke-width="2"><circle cx="22" cy="22" r="1"><animate attributeName="r" begin="0s" dur="1.8s" values="1; 20" calcMode="spline" keyTimes="0; 1" keySplines="0.165, 0.84, 0.44, 1" repeatCount="indefinite"/><animate attributeName="stroke-opacity" begin="0s" dur="1.8s" values="1; 0" calcMode="spline" keyTimes="0; 1" keySplines="0.3, 0.61, 0.355, 1" repeatCount="indefinite"/></circle><circle cx="22" cy="22" r="1"><animate attributeName="r" begin="-0.9s" dur="1.8s" values="1; 20" calcMode="spline" keyTimes="0; 1" keySplines="0.165, 0.84, 0.44, 1" repeatCount="indefinite"/><animate attributeName="stroke-opacity" begin="-0.9s" dur="1.8s" values="1; 0" calcMode="spline" keyTimes="0; 1" keySplines="0.3, 0.61, 0.355, 1" repeatCount="indefinite"/></circle></g></svg>');
$oval: url('data:image/svg+xml;utf8,<svg width="25" height="25" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg" stroke="#4273FA"><g fill="none" fill-rule="evenodd"><g transform="translate(1 1)" stroke-width="2"><circle stroke-opacity=".5" cx="18" cy="18" r="18"/><path d="M36 18c0-9.94-8.06-18-18-18"><animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="1s" repeatCount="indefinite"/></path></g></g></svg>');
$puffSmall: url('data:image/svg+xml;utf8,<svg width="30" height="30" viewBox="0 0 44 44" xmlns="http://www.w3.org/2000/svg" stroke="#4273FA"><g fill="none" fill-rule="evenodd" stroke-width="2"><circle cx="22" cy="22" r="1"><animate attributeName="r" begin="0s" dur="1.8s" values="1; 20" calcMode="spline" keyTimes="0; 1" keySplines="0.165, 0.84, 0.44, 1" repeatCount="indefinite"/><animate attributeName="stroke-opacity" begin="0s" dur="1.8s" values="1; 0" calcMode="spline" keyTimes="0; 1" keySplines="0.3, 0.61, 0.355, 1" repeatCount="indefinite"/></circle><circle cx="22" cy="22" r="1"><animate attributeName="r" begin="-0.9s" dur="1.8s" values="1; 20" calcMode="spline" keyTimes="0; 1" keySplines="0.165, 0.84, 0.44, 1" repeatCount="indefinite"/><animate attributeName="stroke-opacity" begin="-0.9s" dur="1.8s" values="1; 0" calcMode="spline" keyTimes="0; 1" keySplines="0.3, 0.61, 0.355, 1" repeatCount="indefinite"/></circle></g></svg>');

.loading-calendar:before {
  content: $puff;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.75);
  z-index: 3;
}

.btn-square-loading,
.btn.loading.btn-square-loading {
  width: 36px;
  height: 31px;
  padding-right: 0.75rem !important;
  text-align: center;

  .loadingSpinner {
    margin-left: -8px;
    left: auto;
    right: auto;
  }
}

.btn-square-mini-loading,
.btn.loading.btn-square-mini-loading {
  width: 27px;
  height: 25px;
  padding-right: 0.75rem !important;
  text-align: center;

  .loadingSpinner {
    margin-left: -8px;
    left: auto;
    right: auto;
  }
}

.magic-switch {
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// resources/assets/admin/js/shift-plan/widgets/ShiftPlanCalendar.vue